<template>
  <span
    :id="id"
    class="cs-link"
    :class="[type, textDecoration, target]">
    <a
      v-if="external"
      :href="href"
      :rel="rel ? rel : undefined"
      :target="target ? target : undefined">
      <slot />
    </a>
    <NuxtLink
      v-else
      :to="href">
      <slot />
    </NuxtLink>
  </span>
</template>

<script setup lang="ts">

type CsLinkType = 'default' | 'disabled';
type TextDecoration = 'underline' | 'none';

defineProps({
  id: { type: String, default: null },
  type: { type: String as () => CsLinkType, default: 'default' },
  textDecoration: { type: String as () => TextDecoration, default: 'underline' },
  href: { type: String, default: undefined },
  external: { type: Boolean, default: true },
  rel: { type: String, default: undefined },
  target: { type: String, default: undefined }
})
</script>

<style lang="sass" scoped>
.cs-link._blank
    background-image: url('~/assets/icons/new-tab.svg')
    background-repeat: no-repeat
    background-position: right center
    padding-right: 25px
.cs-link, .cs-link a
  color: #ac712a
  cursor: pointer
  text-decoration: none
  &:active,
  &:focus,
  &:hover,
  &:visited
    color: #ac712a

.cs-link
  &.underline, &.underline a
    text-decoration: underline
  &.disabled, &.disabled a
    color: #888888
    cursor: default
    &:active,
    &:focus,
    &:hover,
    &:visited
      color: #888888
</style>
